$('.first-cate .owl-carousel').owlCarousel({
    loop:false,
    margin:20,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }

});
$('.second-cate .owl-carousel').owlCarousel({
    loop:false,
    margin:20,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }

});
$('.third-cate .owl-carousel').owlCarousel({
    loop:false,
    margin:20,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }

});

$('.adp-product-grid-list .owl-carousel').owlCarousel({
    loop:false,
    margin:20,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }

});
$('.owl-carousel').owlCarousel({
    loop: true,
    nav:true,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }

});
$('.products-sliders .owl-carousel').owlCarousel({
    loop:false,
    margin:50,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:3
        }
    }

});
$('.certificate-section .owl-carousel').owlCarousel({
    loop:true,
    margin:60,
    nav:true,
    dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
          margin:30,
            items:5
        }
    }

});

